<template>
  <div>
    <div class="top-back row-between">
      <div class="row">
        <div @click="reset" v-if="showHome">
          <svg-icon iconClass="home" className="icons/svg/home.svg"></svg-icon>
        </div>
        <div class="row back" @click="$emit('back')" v-if="showBack">
          <svg-icon iconClass="arrow-left"></svg-icon>
          <span>BACK</span>
        </div>
      </div>

      <div class="row">
        <div @click="clickOpen" v-if="showOperation">
          <svg-icon
            iconClass="setting"
            className="icons/svg/setting.svg"
          ></svg-icon>
        </div>
        <div
          v-if="showCreate"
          @click="$emit('create')"
          style="margin-left: 20px"
        >
          <svg-icon
            iconClass="add1"
            className="icons/svg/setting.svg"
          ></svg-icon>
        </div>
      </div>
    </div>

    <!-- 全局设置弹框 -->
    <a-modal
      v-model="visible"
      :title="null"
      :footer="null"
      :closable="false"
      :width="320"
      wrapClassName="all-modal"
      :bodyStyle="{ 'border-radius': '16px', background: '#fff' }"
      @cancel="visible = false"
    >
      <svg-icon
        class="modal-delete_x ceshi"
        style="width: 14px; height: 14px; fill: #767676"
        iconClass="delete_x"
        className="icons/svg/delete_x.svg"
        @click="visible = false"
      ></svg-icon>
      <SettingContent :visible="visible">
        <template #user>
          <svg-icon
            style="width: 36px; height: 36px"
            iconClass="profile"
            className="icons/svg/profile.svg"
          ></svg-icon>
        </template>
        <svg-icon
          style="width: 16px; height: 16px"
          iconClass="globe"
          className="icons/svg/globe.svg"
        ></svg-icon>
      </SettingContent>
    </a-modal>

    <!--  New Ticket  -->
  </div>
</template>

<script>
import SettingContent from "@/components/CheckList/setting.vue";
export default {
  components: {
    SettingContent,
  },
  props: {
    showHome: {
      type: Boolean,
      default: true,
    },
    showOperation: {
      type: Boolean,
      default: true,
    },
    showCreate: {
      type: Boolean,
      default: false,
    },
    showBack: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    reset() {
      this.$router.replace("/home");
    },
    clickOpen() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.top-back {
  height: 44px;
  padding: 0 1.75rem;
  background: #f2f2f2;

  svg {
    width: 22px;
    height: 22px;
  }
}

/deep/.all-modal {
  display: flex;
  align-items: center;
  .ant-modal {
    padding: 0;
    top: 0;
  }
}

.back {
  svg {
    width: 12px;
    height: 12px;
  }
  span {
    font-size: 16px;
    font-weight: bold;
    color: #767676;
    margin-left: 8px;
    font-family: Arial;
  }
}
</style>
